import React from 'react';

// Display empty message
const NotFound = () => <p>Sorry, nothing here</p>;

export default NotFound;
